import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import mailsListPageDirective from './MailsListPageDirective'
import mailsFormDirective from './MailsFormPageDirective'
import subscribeStatsChart from './SubscribeStatsChart/SubscribeStatsChart';
import openRateMap from './OpenRateMap/OpenRateMap';
import hostsStatsChart from './HostsStatsChart/HostsStatsChart';


let mailsModule = angular.module('cms.pages.mails', [
  uiRouter,
  mailsListPageDirective,
  mailsFormDirective,
  subscribeStatsChart,
  openRateMap,
  hostsStatsChart
])
  .config(routeConfig);

function routeConfig($stateProvider, gettext) {
  /** @ngInject */

  $stateProvider
    .state('mails', {
      url: '/mails?',
      component: 'appMailsList',
      title: gettext('Mails templates'),
      data: {
          requiresAuth: ['ROLE_ADMIN']
      },
      reloadOnSearch: false,
      sidebarMeta: {
        icon: 'ion-email',
        order: 0,
        allow: ['ROLE_ADMIN']
      }
    })
    .state('mailsAdd', {
      url: '/mails/add',
      component: 'appMailsForm',
      title: gettext('Add mail'),
      data: {
          requiresAuth: ['ROLE_ADMIN']
      },
      params: {
        returnState: null
      },
      breadcrumbsMeta: {
        parentState: 'mails'
      }
    })
    .state('mailsEdit', {
      url: '/mails/edit/:id',
      component: 'appMailsForm',
      params: {
        returnState: null
      },
      title: gettext('Edit Mail'),
      data: {
          requiresAuth: ['ROLE_ADMIN']
      },
      breadcrumbsMeta: {
        parentState: 'mails'
      }
    })
  ;
}

export default mailsModule.name;


// WEBPACK FOOTER //
// ./src/cmsPages/Mails/MailsPageModule.js